var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgParentWelcomeModalImage1 = function SvgParentWelcomeModalImage1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 366 192"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "parent-welcome-modal-image-1_svg__a",
    d: "M0 217h382.901V.048H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "parent-welcome-modal-image-1_svg__c",
    d: "M.103 23.93c0 13.217 10.714 23.93 23.93 23.93s23.93-10.713 23.93-23.93C47.963 10.716 37.249 0 24.033 0S.103 10.716.103 23.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "parent-welcome-modal-image-1_svg__e",
    d: "M.103 23.93c0 13.217 10.714 23.93 23.93 23.93s23.93-10.713 23.93-23.93C47.963 10.716 37.249 0 24.033 0S.103 10.716.103 23.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "parent-welcome-modal-image-1_svg__g",
    d: "M.103 23.93c0 13.217 10.714 23.93 23.93 23.93s23.93-10.713 23.93-23.93C47.963 10.716 37.249 0 24.033 0S.103 10.716.103 23.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "parent-welcome-modal-image-1_svg__i",
    d: "M.103 23.93c0 13.217 10.714 23.93 23.93 23.93s23.93-10.713 23.93-23.93C47.963 10.716 37.249 0 24.033 0S.103 10.716.103 23.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "parent-welcome-modal-image-1_svg__k",
    d: "M.103 23.93c0 13.217 10.714 23.93 23.93 23.93s23.93-10.713 23.93-23.93C47.963 10.716 37.249 0 24.033 0S.103 10.716.103 23.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "parent-welcome-modal-image-1_svg__m",
    d: "M.103 23.93c0 13.217 10.714 23.93 23.93 23.93s23.93-10.713 23.93-23.93C47.963 10.716 37.249 0 24.033 0S.103 10.716.103 23.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "parent-welcome-modal-image-1_svg__o",
    d: "M.103 23.93c0 13.217 10.714 23.93 23.93 23.93s23.93-10.713 23.93-23.93C47.963 10.716 37.249 0 24.033 0S.103 10.716.103 23.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "parent-welcome-modal-image-1_svg__q",
    d: "M.103 23.93c0 13.217 10.714 23.93 23.93 23.93s23.93-10.713 23.93-23.93C47.963 10.716 37.249 0 24.033 0S.103 10.716.103 23.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "parent-welcome-modal-image-1_svg__s",
    d: "M.103 23.93c0 13.217 10.714 23.93 23.93 23.93s23.93-10.713 23.93-23.93C47.963 10.716 37.249 0 24.033 0S.103 10.716.103 23.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "parent-welcome-modal-image-1_svg__u",
    d: "M.113 23.946c0 13.197 10.699 23.896 23.897 23.896s23.896-10.699 23.896-23.896S37.207.049 24.01.049.113 10.75.113 23.946"
  }), /*#__PURE__*/React.createElement("path", {
    id: "parent-welcome-modal-image-1_svg__w",
    d: "M.113 23.946c0 13.197 10.699 23.896 23.897 23.896s23.896-10.699 23.896-23.896S37.207.049 24.01.049.113 10.75.113 23.946"
  }), /*#__PURE__*/React.createElement("path", {
    id: "parent-welcome-modal-image-1_svg__y",
    d: "M.113 23.946c0 13.197 10.699 23.896 23.897 23.896s23.896-10.699 23.896-23.896S37.207.049 24.01.049.113 10.75.113 23.946"
  }), /*#__PURE__*/React.createElement("path", {
    id: "parent-welcome-modal-image-1_svg__A",
    d: "M.113 23.946c0 13.197 10.699 23.896 23.897 23.896s23.896-10.699 23.896-23.896S37.207.049 24.01.049.113 10.75.113 23.946"
  }), /*#__PURE__*/React.createElement("path", {
    id: "parent-welcome-modal-image-1_svg__C",
    d: "M.113 23.946c0 13.197 10.699 23.896 23.897 23.896s23.896-10.699 23.896-23.896S37.207.049 24.01.049.113 10.75.113 23.946"
  }), /*#__PURE__*/React.createElement("path", {
    id: "parent-welcome-modal-image-1_svg__E",
    d: "M.113 23.946c0 13.197 10.699 23.896 23.897 23.896s23.896-10.699 23.896-23.896S37.207.049 24.01.049.113 10.75.113 23.946"
  }), /*#__PURE__*/React.createElement("path", {
    id: "parent-welcome-modal-image-1_svg__G",
    d: "M.113 23.946c0 13.197 10.699 23.896 23.897 23.896s23.896-10.699 23.896-23.896S37.207.049 24.01.049.113 10.75.113 23.946"
  }), /*#__PURE__*/React.createElement("path", {
    id: "parent-welcome-modal-image-1_svg__I",
    d: "M.732 18.848c-2.815 12.894 5.355 25.629 18.25 28.444 12.893 2.815 25.628-5.355 28.443-18.249S42.07 3.414 29.176.6a24 24 0 0 0-5.12-.555C13.066.044 3.173 7.672.732 18.848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "parent-welcome-modal-image-1_svg__K",
    d: "M.732 18.848c-2.815 12.894 5.355 25.629 18.25 28.444 12.893 2.815 25.628-5.355 28.443-18.249S42.07 3.414 29.176.6a24 24 0 0 0-5.12-.555C13.066.044 3.173 7.672.732 18.848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "parent-welcome-modal-image-1_svg__M",
    d: "M.732 18.848c-2.815 12.894 5.355 25.629 18.25 28.444 12.893 2.815 25.628-5.355 28.443-18.249S42.07 3.414 29.176.6a24 24 0 0 0-5.12-.555C13.066.044 3.173 7.672.732 18.848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "parent-welcome-modal-image-1_svg__O",
    d: "M.732 18.848c-2.815 12.894 5.355 25.629 18.25 28.444 12.893 2.815 25.628-5.355 28.443-18.249S42.07 3.414 29.176.6a24 24 0 0 0-5.12-.555C13.066.044 3.173 7.672.732 18.848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "parent-welcome-modal-image-1_svg__Q",
    d: "M.732 18.848c-2.815 12.894 5.355 25.629 18.25 28.444 12.893 2.815 25.628-5.355 28.443-18.249S42.07 3.414 29.176.6a24 24 0 0 0-5.12-.555C13.066.044 3.173 7.672.732 18.848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "parent-welcome-modal-image-1_svg__S",
    d: "M.732 18.848c-2.815 12.894 5.355 25.629 18.25 28.444 12.893 2.815 25.628-5.355 28.443-18.249S42.07 3.414 29.176.6a24 24 0 0 0-5.12-.555C13.066.044 3.173 7.672.732 18.848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "parent-welcome-modal-image-1_svg__U",
    d: "M.732 18.848c-2.815 12.894 5.355 25.629 18.25 28.444 12.893 2.815 25.628-5.355 28.443-18.249S42.07 3.414 29.176.6a24 24 0 0 0-5.12-.555C13.066.044 3.173 7.672.732 18.848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "parent-welcome-modal-image-1_svg__W",
    d: "M.732 18.848c-2.815 12.894 5.355 25.629 18.25 28.444 12.893 2.815 25.628-5.355 28.443-18.249S42.07 3.414 29.176.6a24 24 0 0 0-5.12-.555C13.066.044 3.173 7.672.732 18.848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "parent-welcome-modal-image-1_svg__Y",
    d: "M.732 18.848c-2.815 12.894 5.355 25.629 18.25 28.444 12.893 2.815 25.628-5.355 28.443-18.249S42.07 3.414 29.176.6a24 24 0 0 0-5.12-.555C13.066.044 3.173 7.672.732 18.848"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M151.157 110.123a1.47 1.47 0 0 1-.831-.258L90.145 68.758a1.473 1.473 0 0 1-.385-2.048 1.476 1.476 0 0 1 2.05-.385l60.181 41.107a1.473 1.473 0 0 1-.834 2.69M58.92 154.4a1.474 1.474 0 0 1-.26-2.924l158.295-28.396a1.474 1.474 0 1 1 .522 2.901L59.182 154.376a1.5 1.5 0 0 1-.263.024"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF8006",
    d: "M345.207 100.846c0 22.405-45.558 23.222-67.08 37.186-18.975 12.311-30.04 37.108-59.94 43.341-32.15 6.703-88.782-26.903-88.782-69.06 0-42.159 35.308-64.443 94.326-64.443s121.476 10.818 121.476 52.976"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2FA861",
    d: "M142.011 38.234c-9.884-8.938-21.9-3.528-21.743 9.79.113 9.54 4.565 19.41 11.646 25.813l3.203 2.896c2.707 2.447 4.17 6.414 3.636 9.854l-.234 1.507c-.597 3.848 1.611 8.268 4.986 9.977l16.105 8.16 4.547-17.458c.953-3.658-.9-8.238-4.18-10.34l-1.287-.823c-2.933-1.879-4.939-5.601-4.982-9.247l-.05-4.316c-.113-9.541-4.566-19.41-11.647-25.813"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DA75F",
    d: "M184.832 53.066c-1.553-11.049-12.187-14.014-19.243-5.365-5.055 6.196-7.495 14.93-6.382 22.845l.504 3.58c.425 3.025-.766 6.361-2.958 8.287l-.96.844c-2.452 2.154-3.407 6.18-2.156 9.09l5.973 13.884 12.306-8.789c2.578-1.841 3.848-5.78 2.867-8.89l-.384-1.22c-.877-2.781-.167-6.25 1.765-8.618l2.287-2.803c5.054-6.196 7.494-14.93 6.381-22.845"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D864A",
    d: "m159.61 106.23 4.547-17.457c.953-3.658-.9-8.238-4.181-10.34l-1.285-.823c-2.934-1.879-4.94-5.601-4.983-9.247l-.05-4.316c-.114-9.541-4.566-19.41-11.647-25.813-3.916-3.54-8.166-4.83-11.862-4.267-.649 5.696.69 11.798 4.262 16.656q1.822 2.343 3.692 4.615c1.813 2.053 1.73 5.377.18 7.181q-1.137 1.282-2.291 2.534c-2.348 2.497-2.134 7.03.632 9.554a185 185 0 0 0 6.516 5.698c2.293 1.869 2.8 5.64.732 7.64-2.103 2.556-1.832 5.766.775 8.096a173 173 0 0 0 14.962 10.29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7CC36F",
    d: "M169.39 54.898a203 203 0 0 0 2.497-4.99c3.684-8.174 1.642-18.096-3.959-24.023-7.808-8.268-18.806-7.648-25.634 1.445-4.9 6.52-5.807 16.61-1.228 24.317q1.497 2.37 3.043 4.677c1.514 2.097 1.129 5.213-.494 6.765q-1.186 1.1-2.388 2.17c-2.437 2.13-2.655 6.41-.288 9.038a174 174 0 0 0 5.597 5.956c1.983 1.968 2.11 5.558-.018 7.248-2.212 2.208-2.254 5.25-.02 7.68a163 163 0 0 0 13.112 11.05 163 163 0 0 0 11.783-12.453c1.947-2.667 1.562-5.685-.884-7.63-2.306-1.44-2.583-5.022-.835-7.2q2.505-3.191 4.891-6.547c2.056-2.877 1.357-7.105-1.305-8.948a162 162 0 0 1-2.616-1.887c-1.902-1.297-2.399-4.419-1.254-6.668"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2FA861",
    d: "M171.393 93.778c1.947-2.667 1.562-5.684-.884-7.63-2.306-1.44-2.583-5.022-.835-7.2a174 174 0 0 0 4.884-6.538h-17.037a6.635 6.635 0 0 0-6.639 6.631v20.096a162 162 0 0 0 8.728 7.094 163 163 0 0 0 11.783-12.453"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DA75F",
    d: "M159.212 100.133a.92.92 0 0 1-.919-.86l-.915-13.968a16.3 16.3 0 0 1 .543-5.367l1.536-5.617c.825-3.015.64-6.275-.519-9.179l-1.204-3.016a16.4 16.4 0 0 1-.584-10.347l.857-3.132a14.55 14.55 0 0 0-.52-9.18l-3.92-9.821a.92.92 0 1 1 1.713-.683l3.92 9.823a16.4 16.4 0 0 1 .585 10.347l-.856 3.132a14.55 14.55 0 0 0 .518 9.179l1.204 3.016a16.4 16.4 0 0 1 .585 10.347l-1.536 5.616a14.4 14.4 0 0 0-.482 4.762l.915 13.967a.92.92 0 0 1-.92.981"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D864A",
    d: "M159.842 72.41a14.5 14.5 0 0 1-.385 1.911l-1.536 5.617a16.3 16.3 0 0 0-.543 5.367l.915 13.968a.921.921 0 0 0 1.84-.12l-.915-13.968a14.4 14.4 0 0 1 .482-4.762l1.536-5.616a16.4 16.4 0 0 0 .452-2.283c.005-.039.003-.076.003-.114z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M180.186 174.736h-30.85c-7.333 0-13.277-5.939-13.277-13.263V103.59h44.127z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "parent-welcome-modal-image-1_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#parent-welcome-modal-image-1_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F2F3",
    d: "M150.882 174.736h29.304V103.59h-29.304z",
    mask: "url(#parent-welcome-modal-image-1_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D3A8A",
    d: "M313.393 174.736h-163.27a6.635 6.635 0 0 1-6.64-6.632v-2.87h176.548v2.87a6.635 6.635 0 0 1-6.638 6.632",
    mask: "url(#parent-welcome-modal-image-1_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#224BBE",
    d: "M246.055 165.282a3.49 3.49 0 0 1-3.479 3.476h-21.637a3.49 3.49 0 0 1-3.48-3.476zM299.964 68.704H163.551a6.635 6.635 0 0 0-6.639 6.632v89.946h149.69V75.336a6.635 6.635 0 0 0-6.638-6.632",
    mask: "url(#parent-welcome-modal-image-1_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0E0FD",
    d: "M297.445 75.093H166.07a2.654 2.654 0 0 0-2.656 2.652v87.537H300.1V77.745a2.654 2.654 0 0 0-2.655-2.652",
    mask: "url(#parent-welcome-modal-image-1_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M170.988 165.234h121.539V82.466H170.988z",
    mask: "url(#parent-welcome-modal-image-1_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#366AFF",
    d: "M170.988 106.346h121.539V86.82H170.988z",
    mask: "url(#parent-welcome-modal-image-1_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#89BFF8",
    d: "M177.588 115.036h26.214v-1.36h-26.214zM177.588 119.04h13.107v-1.358h-13.107zM205.853 132.09h-27.04a1.224 1.224 0 0 1-1.225-1.224v-4.545c0-.676.548-1.223 1.224-1.223h27.041c.677 0 1.225.547 1.225 1.223v4.545c0 .676-.548 1.223-1.225 1.223M177.588 136.774h6.229v-1.359h-6.229zM205.853 147.091h-27.04a1.224 1.224 0 0 1-1.225-1.223v-4.545c0-.676.548-1.223 1.224-1.223h27.041c.677 0 1.225.547 1.225 1.223v4.545c0 .676-.548 1.223-1.225 1.223M177.588 151.776h6.229v-1.36h-6.229zM205.853 162.093h-27.04a1.224 1.224 0 0 1-1.225-1.223v-4.545c0-.676.548-1.224 1.224-1.224h27.041c.677 0 1.225.548 1.225 1.224v4.545c0 .676-.548 1.223-1.225 1.223",
    mask: "url(#parent-welcome-modal-image-1_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#224BBE",
    d: "M170.988 86.82h121.539v-4.354H170.988z",
    mask: "url(#parent-welcome-modal-image-1_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M174.205 84.643a.794.794 0 1 1-1.588-.001.794.794 0 0 1 1.588 0M177.342 84.643a.794.794 0 1 1-1.588-.001.794.794 0 0 1 1.588 0M180.48 84.643a.794.794 0 1 1-1.588-.001.794.794 0 0 1 1.588 0M281.827 100.614a4.129 4.129 0 1 1 0-8.258 4.129 4.129 0 1 1 0 8.258",
    mask: "url(#parent-welcome-modal-image-1_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#89BFF8",
    d: "M261.146 121.747H219.07a1.327 1.327 0 0 1-1.327-1.326v-5.4c0-.732.594-1.326 1.327-1.326h42.077c.734 0 1.328.594 1.328 1.327v5.399c0 .732-.594 1.326-1.328 1.326",
    mask: "url(#parent-welcome-modal-image-1_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M221.539 118.642h28.912V116.8h-28.912z",
    mask: "url(#parent-welcome-modal-image-1_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#89BFF8",
    d: "M223.488 129.09a2.87 2.87 0 0 1-2.873 2.87 2.87 2.87 0 0 1-2.873-2.87 2.87 2.87 0 0 1 2.873-2.87 2.87 2.87 0 0 1 2.873 2.87M227.402 130.26h56.659v-2.341H227.4zM223.488 138.965a2.87 2.87 0 0 1-2.873 2.87 2.87 2.87 0 0 1-2.873-2.87 2.87 2.87 0 0 1 2.873-2.87 2.87 2.87 0 0 1 2.873 2.87M227.402 140.135h41.505v-2.34h-41.505zM223.488 148.84a2.87 2.87 0 0 1-2.873 2.87 2.87 2.87 0 0 1-2.873-2.87 2.87 2.87 0 0 1 2.873-2.87 2.87 2.87 0 0 1 2.873 2.87M227.402 150.01h56.659v-2.34H227.4z",
    mask: "url(#parent-welcome-modal-image-1_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#091F3D",
    d: "M232.893 71.865a1.135 1.135 0 1 1-2.27-.001 1.135 1.135 0 0 1 2.27.001",
    mask: "url(#parent-welcome-modal-image-1_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D83A3A",
    d: "M347.779 57.01 288.92 20.201l2.936-4.684 58.858 36.809z",
    mask: "url(#parent-welcome-modal-image-1_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B12126",
    d: "M305.505 30.573 288.92 20.2l2.936-4.684L308.44 25.89z",
    mask: "url(#parent-welcome-modal-image-1_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D83A3A",
    d: "m335.853 122.79-5.382-1.28 16.084-67.482 5.382 1.28z",
    mask: "url(#parent-welcome-modal-image-1_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B12126",
    d: "m348.94 67.885-5.382-1.28 2.997-12.577 5.382 1.28z",
    mask: "url(#parent-welcome-modal-image-1_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D3A8A",
    d: "M284.91 26.601a4.37 4.37 0 0 1-1.384-6.007L295.122 2.09a4.38 4.38 0 0 1 6.014-1.382 4.37 4.37 0 0 1 1.383 6.008L290.924 25.22a4.38 4.38 0 0 1-6.015 1.381",
    mask: "url(#parent-welcome-modal-image-1_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m294.598 34.852-21.35-13.353 9.407-15.012c1.938-3.091 6.055-4.037 9.15-2.102l10.097 6.315c3.095 1.935 4.041 6.048 2.104 9.14z",
    mask: "url(#parent-welcome-modal-image-1_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M294.596 34.85 273.25 21.5c-8.548-.246-16.997 3.912-21.862 11.676l42.244 26.418c4.865-7.763 4.918-17.172.963-24.745",
    mask: "url(#parent-welcome-modal-image-1_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0E0FD",
    d: "m283.697 28.034-10.446-6.533c-8.548-.245-16.997 3.912-21.862 11.676l10.446 6.533c4.866-7.764 13.315-11.921 21.862-11.676",
    mask: "url(#parent-welcome-modal-image-1_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0E0FD",
    d: "M283.923 28.175 273.248 21.5l9.407-15.012c1.938-3.091 6.055-4.037 9.15-2.102l5.048 3.158z",
    mask: "url(#parent-welcome-modal-image-1_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5586F8",
    d: "m286.761 23.646-10.675-6.676-2.838 4.53 10.675 6.675z",
    mask: "url(#parent-welcome-modal-image-1_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#89BFF8",
    d: "m286.761 23.646 10.676 6.677-2.839 4.529-10.675-6.677z",
    mask: "url(#parent-welcome-modal-image-1_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B12126",
    d: "M353.939 53.59a4.81 4.81 0 0 1-3.614 5.766 4.81 4.81 0 1 1-2.159-9.376 4.815 4.815 0 0 1 5.773 3.61",
    mask: "url(#parent-welcome-modal-image-1_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#580C11",
    d: "M349.252 51.699q-.337 0-.672.076a2.95 2.95 0 0 0-1.853 1.318 2.95 2.95 0 0 0-.377 2.24 2.95 2.95 0 0 0 1.32 1.851 2.972 2.972 0 0 0 4.472-3.181 2.95 2.95 0 0 0-1.32-1.851 2.96 2.96 0 0 0-1.57-.453m-.019 9.624a6.6 6.6 0 0 1-3.52-1.016 6.6 6.6 0 0 1-2.957-4.148 6.6 6.6 0 0 1 .845-5.02 6.62 6.62 0 0 1 4.152-2.954 6.62 6.62 0 0 1 5.027.844 6.6 6.6 0 0 1 2.956 4.148c.823 3.575-1.419 7.152-4.997 7.974-.5.115-1.005.172-1.506.172",
    mask: "url(#parent-welcome-modal-image-1_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD13F",
    d: "M345.204 101.011c-.224 22.244-45.608 23.092-67.078 37.022-18.974 12.31-30.038 37.107-59.939 43.34-10.034 2.092-22.454.257-34.792-4.539h-71.89v14.879h246.684V101.01z",
    mask: "url(#parent-welcome-modal-image-1_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M184.681 93.789a3.38 3.38 0 0 0-3.388-3.375 3.385 3.385 0 0 0-3.307 2.635l4.485 3.905a3.39 3.39 0 0 0 2.21-3.165M186.828 94.095l-3.82 3.328 3.154 2.745h.986a.484.484 0 0 0 .484-.483v-5.228a.487.487 0 0 0-.487-.483.52.52 0 0 0-.317.12M177.915 93.298v6.386c0 .267.217.484.484.484h7.425z",
    mask: "url(#parent-welcome-modal-image-1_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#366AFF",
    d: "m186.018 100.314-.176.202-8.123-7.058.176-.202z",
    mask: "url(#parent-welcome-modal-image-1_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M345.002 168.227c-.168 0-.34-.029-.507-.09L259.832 137.2a1.473 1.473 0 1 1 1.014-2.768l84.663 30.937a1.473 1.473 0 0 1-.507 2.858",
    mask: "url(#parent-welcome-modal-image-1_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0E0FD",
    d: "M381.303 166.548c0 13.34-10.825 24.153-24.178 24.153s-24.178-10.813-24.178-24.153 10.825-24.153 24.178-24.153 24.178 10.814 24.178 24.153",
    mask: "url(#parent-welcome-modal-image-1_svg__b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(317 142)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "parent-welcome-modal-image-1_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#parent-welcome-modal-image-1_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#224BBE",
    d: "M13.728 16.692c-1.533 8.05-2.941 4.873-5.71 8.449-2.767 3.575 1.99 5.19-2.508 9.097-4.498 3.908-1.211 9.097-1.211 9.097h20.1V9.29s-9.258-.012-10.67 7.403",
    mask: "url(#parent-welcome-modal-image-1_svg__d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(317 142)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "parent-welcome-modal-image-1_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#parent-welcome-modal-image-1_svg__e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1D3A8A",
    d: "M19.522 20.977s-4.435 1.8-4.568 9.32c-.055 3.085-4.375 2.502-5.008 7.802-.833 6.988 1.234 9.288 1.234 9.288h7.93l4.047-15.053z",
    mask: "url(#parent-welcome-modal-image-1_svg__f)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(317 142)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "parent-welcome-modal-image-1_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#parent-welcome-modal-image-1_svg__g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#224BBE",
    d: "M33.744 16.327c1.533 8.05 2.757 5.173 3.442 9.643.492 3.206-1.63 5.27 2.868 9.177 4.499 3.907 1.803 8.188 1.803 8.188H24.398V9.29s7.934-.377 9.346 7.038",
    mask: "url(#parent-welcome-modal-image-1_svg__h)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(317 142)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "parent-welcome-modal-image-1_svg__j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#parent-welcome-modal-image-1_svg__i"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1D3A8A",
    d: "M31.058 19.521s1.548 3.806 1.371 8.353c-.149 3.834.46 7.534 2.507 8.95L33.528 39.3l-7.105-1.858.382-8.304z",
    mask: "url(#parent-welcome-modal-image-1_svg__j)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(317 142)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "parent-welcome-modal-image-1_svg__l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#parent-welcome-modal-image-1_svg__k"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M15.695 36.547c-3.738 1.11-6.755 2.127-10.049 3.296a9.62 9.62 0 0 0-5.97 6.234l24.934 11.52v-21.05z",
    mask: "url(#parent-welcome-modal-image-1_svg__l)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(317 142)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "parent-welcome-modal-image-1_svg__n",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#parent-welcome-modal-image-1_svg__m"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M33.525 36.547c3.738 1.11 6.756 2.127 10.049 3.296a9.62 9.62 0 0 1 5.97 6.234L24.61 57.431V36.547z",
    mask: "url(#parent-welcome-modal-image-1_svg__n)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(317 142)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "parent-welcome-modal-image-1_svg__p",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#parent-welcome-modal-image-1_svg__o"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#366AFF",
    d: "m16.265 36.384-.56.16-.01.012a8.918 8.918 0 1 0 17.83 0l-.009-.012-.561-.16c-2.16-.615-4.334-3.222-4.334-5.141v-3.595H20.6v3.594c0 1.92-2.174 4.527-4.334 5.142",
    mask: "url(#parent-welcome-modal-image-1_svg__p)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(317 142)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "parent-welcome-modal-image-1_svg__r",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#parent-welcome-modal-image-1_svg__q"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#224BBE",
    d: "M24.61 34.574c1.823 0 3.352-.5 4.613-1.359-.375-.67-.602-1.356-.602-1.972v-3.595H20.6v3.594c0 .617-.226 1.304-.602 1.973 1.261.859 2.79 1.359 4.613 1.359",
    mask: "url(#parent-welcome-modal-image-1_svg__r)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(317 142)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "parent-welcome-modal-image-1_svg__t",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#parent-welcome-modal-image-1_svg__s"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#366AFF",
    d: "M29.756 13.65c1.719 1.906 1.008 5.004 1.504 8.253.877 5.745-1.498 10.43-6.862 10.43-3.64 0-6.171-2.178-6.373-5.587-.276-4.655-.295-5.17 2.22-6.114 3.112-1.169 7.36-3.342 9.51-6.982",
    mask: "url(#parent-welcome-modal-image-1_svg__t)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C0E0FD",
    d: "M97 59c0 13.255-10.745 24-24 24S49 72.255 49 59s10.745-24 24-24 24 10.745 24 24"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49 35)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "parent-welcome-modal-image-1_svg__v",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#parent-welcome-modal-image-1_svg__u"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C0E0FD",
    d: "M47.906 23.946c0 13.197-10.699 23.896-23.897 23.896S.113 37.143.113 23.946 10.812.049 24.009.049s23.897 10.7 23.897 23.897",
    mask: "url(#parent-welcome-modal-image-1_svg__v)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49 35)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "parent-welcome-modal-image-1_svg__x",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#parent-welcome-modal-image-1_svg__w"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D73A3A",
    d: "M35.133 31.929c.562-.977.08-2.335.642-3.626 1.006-2.31 2.708-2.09 2.53-3.665-.137-1.216-1.696-2.403-1.524-3.52.24-1.558 1.332-1.966 1.61-2.889.208-.694.454-1.283-1.29-2.915-1.102-1.03-.125-3.365-1.767-4.143-.587-.277-2.585.408-3.16-.47-.69-1.055-1.322-3.515-2.205-3.96-.92-.464-2.407.252-3.708.498-2.811.53-3.704-1.676-5.498-1.423-1.795.254-2.417 2.575-3.774 2.575-1.356 0-2.71-2.219-4.374.822s-2.867.395-5.083 2.384c-1.674 1.503 1.064 3.704.436 5.295-.517 1.31-1.561 1.724-1.25 2.988.388 1.567 1.358.76 2.8 2.796 1.443 2.037-1.35 3.77.345 4.752 3.063 1.775 1.906 3.915 2.886 4.984.882.962 4.601.68 5.599 1.566 2.28 2.025 3 2.721 5.703 2.714 2.347-.007 4.015-1.19 5.781-2.753 1.17-1.035 4.044.173 5.3-2.01",
    mask: "url(#parent-welcome-modal-image-1_svg__x)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49 35)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "parent-welcome-modal-image-1_svg__z",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#parent-welcome-modal-image-1_svg__y"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1D3A8A",
    d: "M43.31 80.113H17.62l-1.787-17.356a6.76 6.76 0 0 0-2.673-4.72l-.062-.047a6.764 6.764 0 0 1-1.556-9.189l-2.235-1.887c-2.134-.533.96-7.192 7.312-7.312l17.356-1.486a5.45 5.45 0 0 1 5.2 2.17c3.222 4.4 3.665 9.583 3.545 15.037-.089 4.032-.783 19.832-.783 19.832z",
    mask: "url(#parent-welcome-modal-image-1_svg__z)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49 35)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "parent-welcome-modal-image-1_svg__B",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#parent-welcome-modal-image-1_svg__A"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#366AFF",
    d: "M19.105 40.334s-3.415 6.122 2.106 7.544c5.522 1.422 12.018-6.801 10.777-9.465 0 0-4.46.665-4.46-3V31.93h-7.476v5.158s.114 1.924-.947 3.247",
    mask: "url(#parent-welcome-modal-image-1_svg__B)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49 35)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "parent-welcome-modal-image-1_svg__D",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#parent-welcome-modal-image-1_svg__C"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#224BBE",
    d: "m27.529 35.46-.002-.046v-3.485h-7.475v4.6c.648.37 1.38.632 2.213.748 2.11.294 3.873-.424 5.264-1.818",
    mask: "url(#parent-welcome-modal-image-1_svg__D)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49 35)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "parent-welcome-modal-image-1_svg__F",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#parent-welcome-modal-image-1_svg__E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#366AFF",
    d: "M31.954 25.241c-.838 6.017-3.865 10.741-8.75 10.061S16.7 29.25 17.537 23.233s3.484-8 8.368-7.32 6.887 3.311 6.05 9.328",
    mask: "url(#parent-welcome-modal-image-1_svg__F)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49 35)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "parent-welcome-modal-image-1_svg__H",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#parent-welcome-modal-image-1_svg__G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D73A3A",
    d: "M30.555 17.935s-1.78-1.936-6.588.866c-3.192 1.86-5.577 1.039-6.64.716l-.285-3.393 11.383-1.586z",
    mask: "url(#parent-welcome-modal-image-1_svg__H)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 125)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "parent-welcome-modal-image-1_svg__J",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#parent-welcome-modal-image-1_svg__I"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C0E0FD",
    d: "M47.425 29.043c-2.815 12.894-15.55 21.064-28.444 18.249S-2.083 31.742.732 18.848 16.282-2.216 29.176.599s21.064 15.55 18.25 28.444",
    mask: "url(#parent-welcome-modal-image-1_svg__J)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 125)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "parent-welcome-modal-image-1_svg__L",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#parent-welcome-modal-image-1_svg__K"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D83A3A",
    d: "M15.177 40.86 1.516 42.479a26.5 26.5 0 0 0-5.757 1.345l-11.698 4.154 6.4 15.922 8.883-2.895 4.762 30.781H43.55l2.872-32.288 12.026-2.422-1.984-18.165-8.33 1.33v-.003l-15.644.397z",
    mask: "url(#parent-welcome-modal-image-1_svg__L)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 125)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "parent-welcome-modal-image-1_svg__N",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#parent-welcome-modal-image-1_svg__M"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#366AFF",
    d: "M30.355 38.646V29.53H17.312v9.338a1.99 1.99 0 0 1-1.965 1.99l-.17.003c.508 4.33 4.184 7.69 8.65 7.69 4.494 0 8.191-3.547 8.663-7.915l-.118.002a1.99 1.99 0 0 1-2.017-1.99",
    mask: "url(#parent-welcome-modal-image-1_svg__N)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 125)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "parent-welcome-modal-image-1_svg__P",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#parent-welcome-modal-image-1_svg__O"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#224BBE",
    d: "M17.312 29.529v4.738c1.462 2.03 3.62 3.3 6.522 3.3 2.9 0 5.06-1.27 6.521-3.3V29.53z",
    mask: "url(#parent-welcome-modal-image-1_svg__P)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 125)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "parent-welcome-modal-image-1_svg__R",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#parent-welcome-modal-image-1_svg__Q"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#366AFF",
    d: "M16.91 25.128c.487 1.297.021 2.672-1.04 3.071-1.063.399-2.318-.33-2.805-1.627s-.022-2.672 1.04-3.071 2.318.33 2.805 1.627",
    mask: "url(#parent-welcome-modal-image-1_svg__R)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 125)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "parent-welcome-modal-image-1_svg__T",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#parent-welcome-modal-image-1_svg__S"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#366AFF",
    d: "M30.757 25.128c-.487 1.297-.021 2.672 1.04 3.071 1.063.399 2.318-.33 2.806-1.627.487-1.297.02-2.672-1.04-3.071-1.063-.399-2.319.33-2.806 1.627",
    mask: "url(#parent-welcome-modal-image-1_svg__T)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 125)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "parent-welcome-modal-image-1_svg__V",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#parent-welcome-modal-image-1_svg__U"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#224BBE",
    d: "M16.832 13.606S16.735 8.79 23.3 8.934c3.76.082 10.153.863 10.684-2.275 0 0 2.307 7.245-6.593 9.584z",
    mask: "url(#parent-welcome-modal-image-1_svg__V)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 125)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "parent-welcome-modal-image-1_svg__X",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#parent-welcome-modal-image-1_svg__W"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#366AFF",
    d: "M32.68 23.44c0 6.42-2.852 11.807-8.846 11.807s-8.847-5.387-8.847-11.808c0-6.42 2.853-11.626 8.847-11.626S32.68 17.02 32.68 23.44",
    mask: "url(#parent-welcome-modal-image-1_svg__X)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 125)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "parent-welcome-modal-image-1_svg__Z",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#parent-welcome-modal-image-1_svg__Y"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#224BBE",
    d: "M23.833 10.996s-11.582-.014-9.62 12.443l1.712 1.202c.95-1.95-.773-2.784.81-6.822s4.255-.458 7.098-.458 5.517-3.58 7.1.458-.141 4.872.809 6.822l1.711-1.202c1.963-12.457-9.62-12.443-9.62-12.443",
    mask: "url(#parent-welcome-modal-image-1_svg__Z)"
  })))));
};
export default SvgParentWelcomeModalImage1;